import { getChromeManagement, getChromeRuntime } from '../chrome/wrappers';
import { clearSessionStorage } from '../chrome/session';
import { clearLocalStorage, getDeviceAndUserStore } from '../storage/stores';
import { deleteDevice } from '../api/device';
import { cancelActiveTamperingChecks } from '../tampering';

declare const isDelegation: boolean;

/**
 * Logs out the extension.
 *
 * Family: Uninstalls the extension.
 *
 * Delegation: Deletes the device from backend, cleans all the storage data, and reloads the extension to the initial state.
 */
export const logout = () => {
  if (isDelegation) {
    return delegationLogout();
  } else {
    return familyLogout();
  }
};

const delegationLogout = async () => {
  const deviceUid = getDeviceAndUserStore().get()?.device;
  if (deviceUid) {
    // We want to continue cleaning the extension even if the delete call fails.
    try {
      await deleteDevice(deviceUid);
    } catch (error) {
      console.error(error);
    }
  }
  await clearSessionStorage();
  await clearLocalStorage();
  // This will reload the extension, stopping the current execution of the service
  // and starting it again. Therefore, the background script will be called again.
  getChromeRuntime().reload();
};

// Unlike with Delegation, we don't want to delete the device from backend with Family.
// Devices are removed only for delegation for keeping things tidy,
// as the devices are not reusable anymore after a opt-out.
const familyLogout = async () => {
  // Tampering check needs to be canceled to prevent reporting uninstallation as a tampering
  await cancelActiveTamperingChecks();
  return getChromeManagement().uninstallSelf();
};
